<template>
  <div :class="$style.form">
    <Canvas :url="image" :value="value" @input="$emit('input', $event)" />
    <div :class="{ [$style.file]: true, [$style.fileHasImage]: !!image }">
      Choose file
      <input :class="$style.input" type="file" @change="onFileUpload">
    </div>

  </div>
</template>

<script>
import Canvas from './Canvas'

import loadImage from './helpers'

export default {
  props: ['value', 'image'],
  components: {
    Canvas
  },
  methods: {
    async onFileUpload(event) {
      const image = await loadImage(event)
      this.$emit('image', image)
        this.$gtag.event('upload-cwh', {
        'event_category': 'analysis',
        'event_label': 'submit-click',
        'value': 1
      })
    }
  }
}
</script>

<style lang="scss" module>
.form {
  width: 100%;
  height: 100%;
  margin: auto;

  @media (min-width: 760px) {
    height: auto;
  }
}

.file {
  margin-top: 10px;
  padding: 5px 15px;
  border-radius: 5px;
  background-color: #000;
  color: #fff;

  @media (max-width: 768px) {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  @media (min-width: 768px) {
    position: relative;
    display: inline-block;
    cursor: pointer;
    transform: none;
  }
}

.fileHasImage {
  @media (max-width: 768px) {
    display: none;
  }
}

.input {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  opacity: 0;
}
</style>

